import React from "react"
import cx from "classnames"

import { DatasetHeader } from "../../elements"

type Props = {
  className?: string
  children: JSX.Element | JSX.Element[]
  title?: string
}

function Table({ children, title, className }: Props) {
  return (
    <div className={cx(className)}>
      {title && <DatasetHeader>{title}</DatasetHeader>}
      <table className="w-full table-fixed">{children}</table>
    </div>
  )
}

export default Table
